<div class="m-3">
    @for (exp of exploitationList; track exp.id) {
        <div class="row my-3">
            <!-- Nom -->
            <div class="col-md-4 col-lg-4 mb-4">
                <span class="label">Nom :</span>
                <p>{{ exp.name }}</p>
            </div>

            <!-- Professionnel
            <div class="col-md-4 col-lg-4 mb-4">
                <span class="label">Professionel :</span>
                <p>{{ exp.professional ? 'Oui' : 'Non' }}</p>
            </div>
 -->

            <!-- Statut -->
            <div class="col-md-4 col-lg-4 mb-4">
                <span class="label">Statut :</span>
                <p>{{ exp.flag == 0 ? 'Inactive' : 'Active' }}</p>
            </div>

            <!-- Statut -->
            <div class="col-md-4 col-lg-4 mb-4">
                <span class="label">Type :</span>
                <p>{{ exp.type.name }}</p>
            </div>

            <!-- Lon -->
            <div class="col-md-4 col-lg-4 mb-4">
                <span class="label">Lon :</span>
                <p>{{ exp.lon }}</p>
            </div>

            <!-- Lat -->
            <div class="col-md-4 col-lg-4 mb-4">
                <span class="label">Lat :</span>
                <p>{{ exp.lat }}</p>
            </div>
                        <!-- Détails -->
            <div class="col-md-4 col-lg-4 mb-4">
                <span class="label">Détails :</span>
                <p>{{ exp.details }}</p>
            </div>
        </div>
        <hr *ngIf="!$last"/>
    } @empty {
        <div class="no-client-details mx-3 mt-3">
            <p>Aucun détail de client disponible.</p>
        </div>
    }
</div>
